import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-linux-e1-series',
  templateUrl: './linux-e1-series.component.html',
  styleUrls: []
})
export class LinuxE1SeriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}